import React, {useCallback, useContext, useEffect, useState} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import {useHttp} from '../hooks/http.hook'
import {AuthContext} from '../context/AuthContext'
import {LoaderClass} from '../elements/LoaderClass'
import config from '../config.json'
import {
    getAuthHeader, getItems,
    getLocalStorageItem,
    getPathAndQueryParams,
    objectLang,
    setErrorWindow,
    setLocalStorageItem
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import $ from "jquery"
import {WindowPopup} from "../components/WindowPopup"
import {LinksClass} from "../components/LinksClass"

export const FolderDetailPage = () => {
    setLocalStorageItem('page', 'FolderDetailPage')

    let lang = objectLang().language
    const l = lang.lang
    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    const [folder, setFolder] = useState({})
    const [owner, setOwner] = useState({})
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const folderId = useParams().id
    const navigate = useNavigate()

    let host
    window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender

    const getFolder = useCallback(async () => {
        const lang = objectLang().language
        const l = lang.lang
        try {
            const data = await request(
                `${host}/api/folder/detail/${folderId}`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
                setFolder(data.folder)
                setOwner(data.owner)
                const path = data.folder.path
                path.pop()
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }, [auth, folderId, request, host])

    useEffect(() => {
        getFolder().then()
    }, [getFolder])

    // const updateFolderHandler = () => {
    //     $('#name').attr('disabled', false)
    //     $('#description').attr('disabled', false)
    // }

    // const removeFolderHandler = () => {
    //     setDataModal({
    //         title: lang.modal.warnings.title,
    //         desc: `${lang.modal.warnings.desc.deleteFolder}`,
    //         btnCancel: lang.modal.warnings.btnCancel,
    //         btnOK: lang.modal.warnings.btnOK,
    //         clickOK: `replaceTo /${l}/folder/remove/${folder['_id']}`,
    //         clickCancel: 'reload'
    //     })
    //     setAllowed(false)
    // }

    const saveFolderHandler = async () => {
        try {
            const data = await request(`${host}/api/folder/update/${folderId}`, 'POST',
                {
                    parentFID: folder.parentFID,
                    name: $('#name').val(),
                    description: $('#description').val(),
                    owner: folder.owner
                },
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 201) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            }
            if (data['newAccessToken']) auth.accessToken = data['newAccessToken']
            window.location.replace(getPathAndQueryParams())
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    const shareHandler = async () => {
        let openCloseShare = 'closeShareLink'
        if (!folder.accessLink) {
            openCloseShare = 'openShareLink'
        }
        try {
            const data = await request(`${host}/api/folder/${openCloseShare}/${folderId}`, 'PUT',
                {l},
                {
                    Authorization: getAuthHeader(auth)
                })
            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            }
            if (data['newAccessToken']) auth.accessToken = data['newAccessToken']

            // window.location.replace(getPathAndQueryParams())
            navigate(`/${l}/folder/open/${data.folder.parentFolder}`, {replace: true})
        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return <ModalWin data={dataModal}/>
    }

    return (
        <>
            <LinksClass
                auth={auth}
                documents={getLocalStorageItem('documents')}
                items={getItems(getLocalStorageItem('documents'))}
                rootFolder={auth.rootFolder}
            />
            <div className={'container'}>
                {!loading && folder && <WindowPopup
                    lang={lang}
                    title={lang.body.googlePropertiesPage.title}
                    data={{
                        folder,
                        owner,
                        saveFolderHandler,
                        shareHandler,
                        typeData: 'folder-properties',
                        thumb: new URLSearchParams(window.location.search).get('thumb') || '',
                        name: new URLSearchParams(window.location.search).get('name') || '',
                        ownerName: auth.nickName
                    }}
                />}
            </div>
        </>

    )
}
